import {spawnErrorToast, spawnSuccessToast} from '@hm/fundamental'
import {useQueryClient} from '@tanstack/react-query'
import {useCallback, useState} from 'react'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../../../localization'

import {CreateNodeType} from './nodeCreate.types'
import {useCreateNode} from './useCreateNode'

export const useBulkCreateNodes = () => {
  const {t} = useTranslation(FEATURE_NAMESPACE)
  const [inProgress, setInProgress] = useState<boolean>(false)
  const queryClient = useQueryClient()

  // onSuccess callback MUST be provided to override queries invalidation after each step
  const {mutateAsync: createNodeAsync} = useCreateNode({
    onError: (data, variables) => {
      spawnErrorToast(`${t('errors.genericActionError')}: '${variables.Title}'`, {
        closeOnClick: true
      })
    },
    onSuccess: (data, variables) => {
      spawnSuccessToast(`${t('node.createdMessage')}: '${variables.Title}'`, {
        closeOnClick: true
      })
    }
  })

  const bulkCreateNodes = useCallback(
    async ({
      titles,
      parentId,
      onFinish
    }: {
      titles: string[]
      parentId: number
      onFinish: () => void
    }) => {
      setInProgress(true)
      for (const title of titles) {
        try {
          const addData: CreateNodeType = {
            Parent: parentId,
            Title: title,
            Description: title,
            NewAttachments: [],
            CreationMethod: 'createdByAIBulk'
          }
          await createNodeAsync(addData)
        } catch {
          /* PASS */
        }
      }
      await queryClient.invalidateQueries()
      setInProgress(false)
      onFinish?.()
    },
    [createNodeAsync, queryClient]
  )

  return {bulkCreateNodes, inProgress}
}
